






















































































































import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator';
import { ScreenText } from '@/lang/ScreenText';
import { CatalogSession, SessionEnrollmentStatus } from '@/Model/sessions/catalogTypes';
import APP_UTILITIES from '@/utilities/commonFunctions';

import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import bannerSwallowtail from '@/components/icons/banner-swallowtail.vue';
import { VerifiedSiteLocation } from '@/Model/sessions/types';
import { hasCapacityFull, hasScholarCapacityFull, hasWaitListCapacityFull } from '@/utilities/session';
import SessionDiscountBadge from '@/components/familyPortal/sessionCard/SessionDiscountBadge.vue';

@Component({
  components: {
    bannerSwallowtail,
    SessionDiscountBadge
  }
})
export default class SessionCard extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession;
  @PropSync('isAutomaticDiscountEnabled', { type: Boolean }) isAutomaticDiscountEnabledSync!: boolean;
  @PropSync('isMultiparticipantDiscountEnabled', { type: Boolean }) isMultiparticipantDiscountEnabledSync!: boolean;
  @PropSync('isEarlyRegistrationDiscountEnabled', { type: Boolean }) isEarlyRegistrationDiscountEnabledSync!: boolean;

  readonly screenText = new ScreenText();

  /**
   * TODO: Remove this when integrating with the BE
   * This is only for presentational purposes, in the future this value should be retrieved from the session object
  */
  public fixedDiscountAmount = '$50';
  public earlyDiscountDescription = 'Register before May 11 to get $50 off';
  public earlyDiscountName = 'Early Bird';


  public percentageDiscountAmount = '%5';
  public multiDiscountDescription = 'Discounts will be applied after you complete applications for each participant.';
  public multiDiscountName = 'Sibling Discount';

  get hasLocation(): boolean {
    return this.session.siteLocationId !== undefined && this.session.siteLocationId !== null;
  }

  get startDate(): string {
    return APP_UTILITIES.formatLongDateFromDateTime(this.session.startDateTime);
  }

  get endDate(): string {
    return APP_UTILITIES.formatLongDateFromDateTime(this.session.endDateTime);
  }

  get days(): string {
    if (this.session.selectedDays) {
      const abbrMap = new Map(APP_UTILITIES.getDaysAbbreviations(false).map((e) => [e.day, e.abbreviation]));
      return this.session.selectedDays
        .map((e) => abbrMap.get(e))
        .join(', ');
    }
    return '';
  }

  get startTime(): string {
    return APP_UTILITIES.format12HrTimeFromDateTime(this.session.startDateTime, true);
  }

  get endTime(): string {
    return APP_UTILITIES.format12HrTimeFromDateTime(this.session.endDateTime, true);
  }

  get site(): VerifiedSiteLocation | undefined {
    return this.session.siteLocation;
  }

  get isSessionClosed(): boolean {
    return this.session.sessionEnrollmentStatus == SessionEnrollmentStatus.Ended
      || (hasCapacityFull(this.session));
  }

  get isWaitlistOpen(): boolean {
    return hasScholarCapacityFull(this.session) && !hasWaitListCapacityFull(this.session);
  }

  get formattedAgeRestriction(): string {
    // XXX this will need to be localized in future work
    if (this.session.ageFrom) {
      if (this.session.ageTo) {
        if (this.session.ageFrom == this.session.ageTo) {
          return `${this.ageText} ${this.session.ageFrom}`;
        }
        else {
          return `${this.agesText} ${this.session.ageFrom}-${this.session.ageTo}`;
        }
      }
      else {
        return `${this.agesText} ${this.session.ageFrom} ${this.andAboveText}`;
      }
    }
    else if (this.session.ageTo) {
      return `Ages ${this.session.ageTo} ${this.andBelowText}`;
    }
    else {
      return '';
    }
  }

  get waitlistText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_WAITLIST');
  }

  get addToCartText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_ADD_TO_CART');
  }

  get closedText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_CLOSED');
  }

  get ageText(): string {
    return this.screenText.getScreenText('CATALOG_AGE');
  }

  get agesText(): string {
    return this.screenText.getScreenText('CATALOG_AGES');
  }

  get andBelowText(): string {
    return this.screenText.getScreenText('CATALOG_AND_BELOW');
  }

  get andAboveText(): string {
    return this.screenText.getScreenText('CATALOG_AND_ABOVE');
  }
}
